import * as deps from '../../deps';
import * as ing from '../ing';
import * as util from '../util';
import * as TSX from '../TSX/';

import eraseInsertableType from './InsertableType';
import eraseArgumentType from './ArgumentType';
import eraseFunctionType from './FunctionType';
import eraseClassType from './ClassType';
import eraseFieldType from './FieldType';
import eraseVariableType from './VariableType';

export default util.set_erase(erase);
function * erase (            node           )                                {
	switch ( node.kind ) {
		//case NamespaceExportDeclaration:
		case deps.TypeAliasDeclaration:
		case deps.InterfaceDeclaration:
		//case deps.ProtectedKeyword:
		//case deps.ReadonlyKeyword:
		//case deps.PrivateKeyword:
		//case deps.PublicKeyword:
		//case deps.IndexSignature:
		//case deps.AbstractKeyword:
		case deps.ExclamationToken:///
		//case deps.OverrideKeyword:
			return yield util.eraseRange(node);
		case deps.EnumDeclaration:
			const { name } = node                        ;
			throw util.throwPosError(name ? name.pos - 4 : util.RealPos(node), `"enum" is not supported while transpileModule`);
		case deps.ImportEqualsDeclaration:
			const { moduleReference } = node                                ;
			throw util.throwPosError(moduleReference ? moduleReference.pos - 1 : util.RealPos(node), `@ltd/j-ts does not support "import="`);
		case deps.ImportDeclaration:
			if ( ( node                           ).importClause?.isTypeOnly ) { return yield util.eraseRange(node); }
			break;
		case deps.ExportDeclaration:
			if ( ( node                           ).isTypeOnly ) { return yield util.eraseRange(node); }
			break;
		case deps.ExportAssignment:
			if ( ( node                          ).isExportEquals ) {
				const { expression } = node                         ;
				util.throwPosError(expression ? expression.pos - 1 : util.RealPos(node), `@ltd/j-ts does not support "export="`);
			}
			break;
		case deps.Parameter:
			( node                              ).modifiers && util.throwPosError(util.RealPos(( node                              ).name ?? node), `@ltd/j-ts does not support parameter property (readonly / public / protected / private / override)`);
			break;
	}
	if ( node.modifiers ) { for ( const modifier of node.modifiers ) { if ( modifier.kind===deps.DeclareKeyword ) { return yield util.eraseRange(node); } } }
	node.decorators && util.throwPosError(util.RealPos(node.decorators), `@ltd/j-ts can not handle decorator`);
	switch ( node.kind ) {
		case deps.NamedImports:
		case deps.NamedExports:
			const { elements } = node                                         ;
			let ts_index = node.pos;
			let isTypeOnly = false;
			for ( const element of elements ) {
				yield isTypeOnly
					? util.eraseBetween(ts_index, element.pos)
					: util.slice(ts_index, element.pos);
				( isTypeOnly = element.isTypeOnly )
					? yield util.eraseRange(element)
					: yield * util.erase(element);
				ts_index = element.end;
			}
			yield isTypeOnly
				? util.eraseBetween(ts_index, ts_index = elements.end) + util.slice(ts_index, node.end)
				: util.slice(ts_index, node.end);
			return;
		case deps.ModuleDeclaration:
			const { name } = node                          ;
			throw name
				? ing.ts.endsWith('module', name.pos)
					? util.throwPosError(name.pos - 6, `@ltd/j-ts does not support "module" (before ECMAScript proposal finished)`)
					: util.throwPosError(name.pos - 9, `@ltd/j-ts does not support "namespace"`)
				: util.throwPosError(util.RealPos(node), `@ltd/j-ts does not support "module" (before ECMAScript proposal finished) and "namespace"`);
		case deps.CallExpression:
		case deps.NewExpression:
		case deps.TaggedTemplateExpression:
			return yield * eraseArgumentType(node);
		case deps.ExpressionWithTypeArguments: {
			const { expression } = node                                    ;
			if ( node.pos!==expression.pos ) { yield util.slice(node.pos, expression.pos); }
			yield * util.erase(expression);
			yield util.eraseBetween(expression.end, node.end);
			return;
		}
		case deps.VariableDeclaration:
			return yield * eraseVariableType(node                            );
		case deps.PropertyDeclaration:
			return yield * eraseFieldType(node                            );
		case deps.ArrowFunction:
			return yield * eraseFunctionType(node                      );
		case deps.MethodDeclaration:
		case deps.FunctionDeclaration:
			return ( node                                                      ).body
				? yield * eraseFunctionType(node                                                     )
				: yield util.eraseRange(node);
		case deps.FunctionExpression:
			return yield * eraseFunctionType(node                           );
		case deps.GetAccessor:
		case deps.SetAccessor:
		case deps.Constructor:
			return ( node                                                                                            ).body
				? yield * eraseFunctionType(node                                                                                           )
				: yield util.eraseRange(node);
		case deps.ClassDeclaration:
		case deps.ClassExpression:
			return yield * eraseClassType(node                                                );
		case deps.Parameter: {
			const { dotDotDotToken, name, questionToken, type, initializer } = node                             ;
			let ts_index = node.pos;
			if ( dotDotDotToken ) {
				if ( ts_index!==dotDotDotToken.pos ) { yield util.slice(ts_index, dotDotDotToken.pos); }
				yield * util.erase(dotDotDotToken);
				ts_index = dotDotDotToken.end;
			}
			{
				if ( ts_index!==name.pos ) { yield util.slice(ts_index, name.pos); }
				yield * util.erase(name);
				ts_index = name.end;
			}
			if ( questionToken ) { yield util.slice(ts_index, ( ts_index = questionToken.end ) - 1) + ' '; }
			if ( type ) { yield util.slice(ts_index, type.pos - 1) + util.eraseBetween(type.pos - 1, ts_index = type.end); }
			if ( initializer ) {
				if ( ts_index!==initializer.pos ) { yield util.slice(ts_index, initializer.pos); }
				yield * util.erase(initializer);
				ts_index = initializer.end;
			}
			if ( ts_index!==node.end ) { yield util.slice(ts_index, node.end); }
			return;
		}
		case deps.NonNullExpression: {
			const { expression } = node                          ;
			if ( node.pos!==expression.pos ) { yield util.slice(node.pos, expression.pos); }
			yield * util.erase(expression);
			yield util.slice(expression.end, node.end - 1) + ' ';
			return;
		}
		case deps.AsExpression: {
			const { expression, type } = node                     ;
			yield * util.erase(expression);
			yield util.slice(expression.end, type.pos - 2) + util.eraseBetween(type.pos - 2, type.end);
			return;
		}
	}
	if ( TSX.ing ) {
		const generator = TSX.handle(node);
		if ( generator ) { return yield * generator; }
	}
	else {
		switch ( node.kind ) {
			case deps.ReturnStatement:
				return ( node                         ).expression
					? yield * eraseInsertableType(node                        )
					: yield util.codeOf(node);
			case deps.ThrowStatement:
				return yield * eraseInsertableType(node                       );
			case deps.YieldExpression:
				if ( ( node                         ).expression ) {
					if ( ( node                         ).asteriskToken ) {
						const { expression } = node                        ;
						yield util.slice(node.pos, expression .pos);
						yield * util.erase(expression );
						if ( expression .end!==node.end ) { yield util.slice(expression .end, node.end); }
					}
					else { yield * eraseInsertableType(node                        ); }
				}
				else { yield util.codeOf(node); }
				return;
			case deps.TypeAssertionExpression: {
				const { type, expression } = node                      ;
				yield util.slice(node.pos, type.pos - 1) + util.eraseBetween(type.pos - 1, type.end) + util.slice(type.end, expression.pos - 1) + ' ';
				yield * util.erase(expression);
				return;
			}
		}
	}
	let ts_index = node.pos;
	const childNodes = util.ChildNodes(node);
	if ( childNodes ) {
		for ( const child of childNodes ) {
			if ( ts_index!==child.pos ) { yield util.slice(ts_index, child.pos); }
			yield * util.erase(child);
			ts_index = child.end;
		}
	}
	if ( ts_index!==node.end ) { yield util.slice(ts_index, node.end); }
}
